<section>
    <app-swiper-banner [config]="config"></app-swiper-banner>
</section>